<template>
  <v-flex class="ca-hdr">
    <span class="display-18 d-block pt-2">
      <nuxt-link
        :to="`/jobs/cat${catCode}/`"
        :title="catName"
        :class="'display-14 primary--text no-underline py-1 cat-list-item'"
        :prefetch="false"
      >
        {{ catName }}
      </nuxt-link>
    </span>
  </v-flex>
</template>

<script>
export default {
  props: {
    catName: {
      type: String,
      required: false,
      default: '',
    },
    catCode: {
      type: Number,
      required: false,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
}
.ca-hdr p {
  background-color: #f6f7f9;
  padding: 3px 10px 2px 0;
  border-radius: 0 0 5px 5px;
  position: relative;
}
.ca-hdr p:after {
  content: '\276f';
  position: absolute;
  left: 4px;
  color: $primary;
  font-size: 12px;
  line-height: 30px;
}

.test {
  color: red;
}
</style>